import React from "react";
import PageHeader from "components/PageHeader";
import { Segment } from "semantic-ui-react";
import SwitchRouter from "components/SwitchRouter";
import { Route } from "react-router-dom";
import Menu from './Menu'
import Combustiveis from './combustiveis/Combustiveis'
import TabelaPedidos from "./combustiveis/TabelaPedidos";

export default function Inicio({ match: { path } }) {

    return (
        <div id='template-validfisco' className='page-content'>

            <PageHeader compact />

            <Segment className='subcontent py-0'>
                <SwitchRouter>
                    <Route exact path={`${path}`} render={props => <Menu {...props} path={path} />} />
                    <Route exact path={`${path}/combustiveis`} render={props => <Combustiveis {...props} path={path} />} />
                    <Route exact path={`${path}/combustiveis/relatorio`} render={props => <TabelaPedidos {...props} path={path} />} />
                </SwitchRouter>
            </Segment>

        </div>
    )
}